import { SaveState } from 'Webapp/enums';

export const flipPending = ({ magazine: { flipState } }) =>
  flipState === SaveState.PENDING;
